import { useController } from 'react-hook-form';
import Input from '../../../ui/Input';

import IsSkippable from './IsSkippable';
import { useContext } from 'react';
import { BountiesContext } from '../../../contexts/BountiesContext';
import Heading from '../../../ui/Heading';

const UploadFile = ({ register, index, errors, control, microtaskEditDetail }) => {
    const { isEdit } = useContext(BountiesContext);
    return (
        <div>
            <div className="mb-2">
                <Heading type="microtaskTitle" className="capitalize text-textPrimary mb-1">
                    Title <sup className="text-lg relative top-[1px]">*</sup>
                </Heading>
                <Input
                    {...register(`microtasks.${index}.uploadFile_Title`, {
                        required: 'Please enter a title',
                    })}
                    {...(isEdit && { defaultValue: microtaskEditDetail?.uploadFile_Title || '' })}
                    error={errors?.microtasks && errors?.microtasks[index]?.uploadFile_Title?.message}
                    placeholder={'Describe the microtask objective in 1 line'}
                    className={'w-[100%]'}
                />
            </div>

            <div className="mb-2">
                <Heading type="microtaskTitle" className="capitalize text-textPrimary mb-1">
                    Task Description <sup className="text-lg relative top-[1px]">*</sup>
                </Heading>
                <Input
                    {...register(`microtasks.${index}.uploadFile_Description`, {
                        required: 'Please enter a description',
                    })}
                    {...(isEdit && { defaultValue: microtaskEditDetail?.uploadFile_Description || '' })}
                    error={errors?.microtasks && errors?.microtasks[index]?.uploadFile_Description?.message}
                    placeholder={'Describe the task'}
                    className={'w-[100%]'}
                />
            </div>

            {/* <div className="flex gap-9 my-2 items-center ">
                <IsSkippable
                    selectedOption={skippableField.value}
                    onSelectOption={(value) => {
                        skippableField.onChange(value);
                    }}
                    options={['Yes', 'No']}
                />
            </div> */}
        </div>
    );
};

export default UploadFile;
